import { supabase } from '../lib/supabase';

export const emailPreferencesService = {
  /**
   * Get user's email preferences
   */
  async getPreferences() {
    try {
      const { data: { user } } = await supabase?.auth?.getUser();
      if (!user) throw new Error('Not authenticated');

      const { data, error } = await supabase
        ?.from('email_preferences')?.select('*')?.eq('user_id', user?.id)
        ?.maybeSingle();

      if (error) throw error;

      // If no preferences exist yet, return defaults
      if (!data) {
        return {
          weeklyDigestEnabled: false,
          digestDayOfWeek: 1
        };
      }

      return {
        weeklyDigestEnabled: data?.weekly_digest_enabled || false,
        digestDayOfWeek: data?.digest_day_of_week || 1
      };
    } catch (error) {
      console.error('Error fetching email preferences:', error);
      throw error;
    }
  },

  /**
   * Update user's email preferences
   */
  async updatePreferences(preferences) {
    try {
      const { data: { user } } = await supabase?.auth?.getUser();
      if (!user) throw new Error('Not authenticated');

      const { data, error } = await supabase
        ?.from('email_preferences')
        ?.update({
          weekly_digest_enabled: preferences?.weeklyDigestEnabled,
          digest_day_of_week: preferences?.digestDayOfWeek,
          updated_at: new Date()?.toISOString()
        })
        ?.eq('user_id', user?.id)
        ?.select()
        ?.single();

      if (error) throw error;

      return {
        weeklyDigestEnabled: data?.weekly_digest_enabled,
        digestDayOfWeek: data?.digest_day_of_week
      };
    } catch (error) {
      console.error('Error updating email preferences:', error);
      throw error;
    }
  },

  /**
   * Get email digest history
   */
  async getDigestHistory(limit = 10) {
    try {
      const { data: { user } } = await supabase?.auth?.getUser();
      if (!user) throw new Error('Not authenticated');

      const { data, error } = await supabase
        ?.from('email_digest_logs')
        ?.select('*')
        ?.eq('user_id', user?.id)
        ?.order('sent_at', { ascending: false })
        ?.limit(limit);

      if (error) throw error;

      return data?.map(log => ({
        id: log?.id,
        sentAt: log?.sent_at,
        weekStartDate: log?.week_start_date,
        weekEndDate: log?.week_end_date,
        status: log?.status,
        errorMessage: log?.error_message
      }));
    } catch (error) {
      console.error('Error fetching digest history:', error);
      throw error;
    }
  }
};